import React from 'react';
import { Link } from '@reach/router';
import {
  Button,
  ButtonProps,
  Box,
  Link as ExternalLink,
} from '@chakra-ui/react';

const attrs: Partial<ButtonProps> = {
  variant: 'ghost',
  width: '100%',
  color: 'white',
  justifyContent: 'flex-start',
  py: 4,
  px: 6,
  borderRadius: 0,
  _hover: { bg: 'gray.800' },
  _active: { bg: 'gray.900' },
  height: 'auto',
};

const SidebarLink: React.FC<{
  to: string;
  isExternalLink?: boolean;
  icon?: any;
  isInGroup?: boolean;
  isActive?: boolean;
}> = ({ children, to, icon: Icon, isInGroup, isActive, isExternalLink }) => (
  <Box as="li">
    {isExternalLink ? (
      <Button
        {...attrs}
        leftIcon={Icon ? <Icon /> : undefined}
        as={ExternalLink}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        pl={isInGroup ? 12 : 6}
        bg="white"
        color="gray.800"
        _hover={{
          bg: 'gray.200',
          color: 'gray.800',
          fontWeight: 'bold',
          // @ts-ignore
          '&:before': {
            width: 1,
          },
        }}
        _before={{
          content: `""`,
          position: 'absolute',
          top: 0,
          left: 0,
          h: '100%',
          width: isActive ? 1 : 0,
          bg: 'yellow.400',
          transition: '.1s width ease-in',
        }}
        fontWeight={isActive || !isInGroup ? 'bold' : 'normal'}
        _active={{ bg: 'gray.200', fontWeight: 'bold' }}
      >
        {children}
      </Button>
    ) : (
      <Button
        {...attrs}
        leftIcon={Icon ? <Icon /> : undefined}
        as={Link}
        to={to}
        pl={isInGroup ? 12 : 6}
        bg="white"
        color="gray.800"
        _hover={{
          bg: 'gray.200',
          color: 'gray.800',
          fontWeight: 'bold',
          // @ts-ignore
          '&:before': {
            width: 1,
          },
        }}
        _before={{
          content: `""`,
          position: 'absolute',
          top: 0,
          left: 0,
          h: '100%',
          width: isActive ? 1 : 0,
          bg: 'yellow.400',
          transition: '.1s width ease-in',
        }}
        fontWeight={isActive || !isInGroup ? 'bold' : 'normal'}
        _active={{ bg: 'gray.200', fontWeight: 'bold' }}
      >
        <Box textOverflow="ellipsis" overflow="hidden">
          {children}
        </Box>
      </Button>
    )}
  </Box>
);

const SidebarButton: React.FC<
  {
    icon: any;
  } & ButtonProps
> = ({ icon: Icon, onClick, children, ...rest }) => (
  <Button
    {...attrs}
    {...rest}
    leftIcon={<Icon />}
    onClick={onClick}
    variant="ghost"
    bg="white"
    color="gray.800"
    _hover={{
      bg: 'gray.200',
      color: 'gray.800',
    }}
    _active={{ bg: 'gray.200' }}
  >
    <Box textOverflow="ellipsis" overflow="hidden" paddingRight={1}>
      {children}
    </Box>
  </Button>
);

export { SidebarButton, SidebarLink };
